<template>
	
	<!--<input 
		type="file"
		ref="input"
		class="input-sigarus-file"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
		>
	</input>-->

	<div class="file">
		
		<el-button
		type="text" 
		size="mini"
		icon="el-icon-upload"
		@click="uploadFile">
			Subir archivo
		</el-button>

		<input
		type="file"
		ref="input"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
		@change="handleFile" />

	</div>

</template>

<script>
	export default {
		name: 'InputSigarusFile',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) {
					this.$emit('input', val)
				}

			}
		},
		methods: {

			uploadFile() {
				this.$refs.input.value = ''
				this.$refs.input.click()
			},

			async handleFile(e) {

				// Comprobar formato disponible

				let {file,base64} = await this.toBase64(this.$refs.input.files[0])
				
				this.model = {file, base64, name: file.name}

				this.$emit('save') 
			},

			$render(val) {

				return this.value.name || this.value || '-'
			},

			toBase64 (file) {
				
				return new Promise((resolve,reject) => {
					var reader = new FileReader()
					reader.readAsDataURL(file)

					reader.onload = function () {
						resolve({file, base64: reader.result})
					}

					reader.onerror = function (error) {
						console.log('Error: ', error)
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.file {
		padding: 0 0.50rem;
		> p {
			margin: 0;
    		font-size: 12.8px;
			line-height: 20px;
		}
		> input {
			display: none;
		}
	}
</style>
